import type { InjectionKey, Ref } from 'vue';

export interface BaseBreadcrumbsContext {
    divider: Ref<string | object>;
}

export const BaseBreadcrumbs: InjectionKey<BaseBreadcrumbsContext> = Symbol('BaseBreadcrumbs');
